import type { HeaderProps } from './header.types';
import { useEffect } from 'react';
import I18nManager from '@/i18n';
import Alert from './components/alert';
import Content from './components/content';
import Hints from './components/hints';
import Logo from './components/logo';
import Panel from './components/panel';
import Phone from './components/phone';
import Language from '@/components/language';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { cn } from '@/utils/helper';
import v1 from './header-v1.module.css';
import v2 from './header-v2.module.css';

const lang = new I18nManager();

export default function Header(props: HeaderProps) {
  const isInternationalizationOn = useAppSelector(ConfigSlice.selectors.isInternationalizationOn);

  useEffect(() => {
    lang.setIsInternationalizationOn(isInternationalizationOn);
  }, [isInternationalizationOn]);

  return (
    <div className={cn(v1.Header, v2.Header)}>
      <Alert />
      <Content>
        <Logo onClick={props.onClick} />
        <Panel>
          <>
            <Phone />
            <Hints />
          </>
          {(!!window.isInternationalizationOn || isInternationalizationOn) && lang.languages.length > 0 ? (
            <Language />
          ) : null}
        </Panel>
      </Content>
    </div>
  );
}
